// ** React Imports
import { useEffect, useRef, useState } from 'react';

import { client } from 'src/utils/axios-client';
import {
    LeadScreenStore,
    LeadActivity,
    Lead,
    NextActivity,
    LeadAccountStore,
    ViewType,
    ActivityDialogStore,
    LeadCompanyStore,
    CompanyDialogStore,
    LeadSprintStore,
    SprintDialogStore,
    LeadActivityHistoryStore,
    ActivityHistoryDialogStore,
    LeadActivityCadenceStore,
    CadenceListDialogStore,
    LeadActivityOutcomeStore,
    ActivityOutcomes,
    ActivityNotesDialogStore,
    LeadListStore,
} from 'src/stores/LeadStore';
import { getActivityEndpoint, getLeadEndpoint, leadEndpoints, optionsEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import _ from 'lodash';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Icon from 'src/features/common/CustomIcon';
import MenuItem from '@mui/material/MenuItem';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ListItemIcon from '@mui/material/ListItemIcon';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { ProblemDetails } from '../../../types/ApiErrorResponse';
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import IconButton from '@mui/material/IconButton';
import NoteIcon from '@mui/icons-material/Note';
import { id } from 'date-fns/esm/locale';
import CustomDatePickerNoError from '../../common/CustomDatePickerNoError';
import LoadingButton from '@mui/lab/LoadingButton';
import FormControl from '@mui/material/FormControl';
import { SelectOption } from '../../../types/common';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const DoActivityOutcomes = () => {
    const [DoActivityOutcomeshasLoaded, setDoActivityOutcomeshasLoaded] = useState(false);
    const outcomesRecord = LeadActivityOutcomeStore.useState((s) => s.record);
    const selectedLead = LeadScreenStore.useState((s) => s.selectedLead) as Lead;
    const [activityOutcomeError, setactivityOutcomeError] = useState(false);

    const [disabledOutcome, setDisabledOutcome] = useState(false);
    const [hasGroup, setHasGroup] = useState(false);
    const [groupId, setGroupId] = useState('');
    const [outcomeId, setoutcomeId] = useState('');
    const [outcomeSubId, setOutcomeSubId] = useState('');
    const [showSubOutcomes, setShowSubOutcomes] = useState(false);
    const [showGroup, setShowGroup] = useState(false);
    const [showDCSchedule, setShowDCSchedule] = useState(false);
    const [showNextActivity, setShowNextActivity] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [activities, setActivities] = useState([] as SelectOption[]);
    const [selectedActivity, setSelectedActivity] = useState<string>('');

    useEffect(() => {
        setDoActivityOutcomeshasLoaded(true);
    }, [outcomesRecord]);

    const handlenewActivityChange = (event: SelectChangeEvent) => {
        setSelectedActivity(event.target.value as string);
        LeadActivityOutcomeStore.update((s) => {
            s.record.nextActivityId = event.target.value as string;
        });
        LeadActivityOutcomeStore.update((s) => {
            s.record.saveDisabled = false;
        });
    };

    useEffect(() => {
        const load = async () => {
            const response = await client.get(optionsEndpoints.newactivityendpoint);
            setActivities(response.data);
        };

        load();
    }, []);

    useEffect(() => {
        setHasGroup(outcomesRecord.hasGroup);
        setDisabledOutcome(!outcomesRecord.hasGroup);
        setShowGroup(outcomesRecord.hasGroup);
    }, [hasGroup]);

    const handleChange = (event: SelectChangeEvent) => {
        const outcomeId = event.target.value as string;

        const activityOutcomes = outcomesRecord.activitySubOutcomes.filter(
            (record) => record.activityOutcomeId == outcomeId,
        );

        LeadActivityOutcomeStore.update((s) => {
            s.record.selectedId = event.target.value;
        });

        if (activityOutcomes.length > 0) {
            setoutcomeId(event.target.value as string);
            setShowSubOutcomes(true);
            LeadActivityOutcomeStore.update((s) => {
                s.record.saveDisabled = true;
            });
        } else {
            setoutcomeId(event.target.value as string);
            LeadActivityOutcomeStore.update((s) => {
                s.record.saveDisabled = false;
            });
            checkForActions(event.target.value, 'OUTCOME');
        }
    };

    const handleSubChange = (event: SelectChangeEvent) => {
        setOutcomeSubId(event.target.value as string);
        //LeadActivityOutcomeStore.update(s => { s.record.selectedId = event.target.value })
        LeadActivityOutcomeStore.update((s) => {
            s.record.selectedSubId = event.target.value;
        });
        LeadActivityOutcomeStore.update((s) => {
            s.record.saveDisabled = false;
        });
        checkForActions(event.target.value, 'SUBOUTCOME');
    };

    const handleGroupChange = (event: SelectChangeEvent) => {
        setGroupId(event.target.value as string);
        setDisabledOutcome(true);
        setShowGroup(false);
    };

    const goBackToOutcomeFromSub = () => {
        setoutcomeId('');
        setShowSubOutcomes(false);
        setOutcomeSubId('');
        LeadActivityOutcomeStore.update((s) => {
            s.record.saveDisabled = true;
        });
    };

    const goBackToGroupFromOutcome = () => {
        setoutcomeId('');
        setOutcomeSubId('');
        setGroupId('');
        setDisabledOutcome(false);
        setShowGroup(true);
        LeadActivityOutcomeStore.update((s) => {
            s.record.saveDisabled = true;
        });
    };

    const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        LeadActivityOutcomeStore.update((s) => {
            s.record.activityNotes = event.target.value;
        });
    };

    const onSubmit = async () => {
        let hasError = false;
        setSubmitting(true);
        if (_.isEmpty(outcomesRecord.selectedId) && outcomesRecord.hasOutcomes) {
            setactivityOutcomeError(true);
            hasError = true;
        }

        if (hasError) return;

        await client
            .post(leadEndpoints.updateactivityoutcome, outcomesRecord)
            .then(async (response) => {
                LeadScreenStore.update((s) => {
                    //s.selectedView = ViewType.None;
                    s.loadNextLead = true;
                    s.closeOnNoMoreLeads = true;
                });
                setSubmitting(false);

                const updatedLeadResposne = await client.get(getLeadEndpoint.replace('{id}', selectedLead.id));

                LeadListStore.update((s) => {
                    const list = _.cloneDeep(s.list);
                    const leadIndex = list.items.findIndex((s) => s.id == selectedLead.id);
                    const existingLead = list.items[leadIndex];
                    list.items[leadIndex] = { ...existingLead, ...updatedLeadResposne.data };
                    s.list = list;
                });
            })
            .catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        const errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\';
                        });
                    }
                }
            });
    };

    const checkForActions = async (id: string, outcomeType: string) => {
        await client
            .get(leadEndpoints.getoutcomeactions, { params: { id: id, outcomeType: outcomeType } })
            .then(async (response) => {
                setShowDCSchedule(false);
                setShowNextActivity(false);
                if (response.data == 'Referral') {
                    LeadScreenStore.update((s) => {
                        s.selectedLead = selectedLead;
                        s.isAddReferralPopup = true;
                    });
                }
                if (response.data == 'DC Scheduled') {
                    setShowDCSchedule(true);
                }
                if (response.data == 'New Activity') {
                    LeadActivityOutcomeStore.update((s) => {
                        s.record.saveDisabled = true;
                    });
                    setShowNextActivity(true);
                }
            })
            .catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        const errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\';
                        });
                    }
                }
            });
    };

    const viewActivityNotes = () => {
        ActivityNotesDialogStore.update((s) => {
            s.activityNotesDialogMode = true;
        });
    };

    if (DoActivityOutcomeshasLoaded && !outcomesRecord.configurationIssue) {
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Box>
                                    <Grid container alignContent="center">
                                        {!outcomesRecord.showNotesPopup && (
                                            <Grid item xs={12} spacing={2}>
                                                <TextField
                                                    id="activityNotes"
                                                    label="Activity Notes"
                                                    multiline
                                                    rows={6}
                                                    placeholder="Enter activity notes here..."
                                                    onChange={handleTextChange}
                                                    fullWidth
                                                />
                                            </Grid>
                                        )}
                                        {outcomesRecord.showNotesPopup && (
                                            <Grid item xs={12} spacing={2}>
                                                <Tooltip title="Add Activity Notes">
                                                    <Button
                                                        variant="outlined"
                                                        startIcon={<NoteIcon />}
                                                        size="small"
                                                        onClick={viewActivityNotes}
                                                    >
                                                        Activity Notes
                                                    </Button>
                                                </Tooltip>
                                            </Grid>
                                        )}
                                        {outcomesRecord.hasOutcomes && hasGroup && showGroup && (
                                            <Grid
                                                item
                                                xs={12}
                                                md={12}
                                                spacing={2}
                                                alignContent="center"
                                                justifyContent={'center'}
                                                sx={{
                                                    pt: 4,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <InputLabel id="demo-simple-select-autowidth-label2">
                                                    Select Outcome Group
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-autowidth-label2"
                                                    id="outcomeGroupId"
                                                    value={groupId}
                                                    size="small"
                                                    autoWidth
                                                    displayEmpty
                                                    onChange={handleGroupChange}
                                                    error={activityOutcomeError}
                                                >
                                                    {outcomesRecord.activityOutcomeGroups.map((record) => (
                                                        <MenuItem
                                                            key={record.outcomeGroupId}
                                                            value={record.outcomeGroupId}
                                                        >
                                                            <Grid container spacing={2} justifyContent={'center'}>
                                                                <Grid item xs={12} md={2}>
                                                                    {record.icon && (
                                                                        <Tooltip
                                                                            title={record.tooltip}
                                                                            key={record.outcomeGroupId}
                                                                            placement="right"
                                                                        >
                                                                            <ListItemIcon>
                                                                                <Icon
                                                                                    icon={record.icon}
                                                                                    sx={{ color: record.buttonColor }}
                                                                                ></Icon>
                                                                            </ListItemIcon>
                                                                        </Tooltip>
                                                                    )}
                                                                    {!record.icon && (
                                                                        <Tooltip
                                                                            title={record.tooltip}
                                                                            key={record.outcomeGroupId}
                                                                            placement="right"
                                                                        >
                                                                            <ListItemIcon>
                                                                                <SaveTwoToneIcon sx={{ opacity: 0 }} />
                                                                            </ListItemIcon>
                                                                        </Tooltip>
                                                                    )}
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    md={10}
                                                                    justifyContent={'left'}
                                                                    alignItems="left"
                                                                >
                                                                    <Tooltip
                                                                        title={record.tooltip}
                                                                        key={record.outcomeGroupId}
                                                                        placement="right"
                                                                    >
                                                                        <Typography
                                                                            variant="inherit"
                                                                            noWrap
                                                                            sx={{ color: record.buttonColor }}
                                                                            align="left"
                                                                        >
                                                                            &nbsp; {record.name}
                                                                        </Typography>
                                                                    </Tooltip>
                                                                </Grid>
                                                            </Grid>
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {activityOutcomeError && (
                                                    <Typography
                                                        variant="caption"
                                                        noWrap
                                                        sx={{ color: 'red' }}
                                                        align="left"
                                                    >
                                                        Outcome is required!
                                                    </Typography>
                                                )}
                                            </Grid>
                                        )}
                                        {outcomesRecord.hasOutcomes && disabledOutcome && !showSubOutcomes && (
                                            <Grid
                                                item
                                                xs={12}
                                                md={12}
                                                spacing={2}
                                                alignContent="center"
                                                justifyContent={'center'}
                                                sx={{
                                                    pt: 4,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <InputLabel id="demo-simple-select-autowidth-label">
                                                    Select Outcome
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-autowidth-label"
                                                    id="selectedId"
                                                    value={outcomeId}
                                                    size="small"
                                                    autoWidth
                                                    displayEmpty
                                                    onChange={handleChange}
                                                    error={activityOutcomeError}
                                                >
                                                    {outcomesRecord.activityOutcomes
                                                        .filter(
                                                            (record) =>
                                                                groupId == '' || record.outcomeGroupId == groupId,
                                                        )
                                                        .map((record) => (
                                                            <MenuItem key={record.outcomeId} value={record.outcomeId}>
                                                                <Grid container spacing={2} justifyContent={'center'}>
                                                                    <Grid item xs={12} md={2}>
                                                                        {record.icon && (
                                                                            <Tooltip
                                                                                title={record.tooltip}
                                                                                key={record.outcomeId}
                                                                                placement="right"
                                                                            >
                                                                                <ListItemIcon>
                                                                                    <Icon
                                                                                        icon={record.icon}
                                                                                        sx={{
                                                                                            color: record.buttonColor,
                                                                                        }}
                                                                                    ></Icon>
                                                                                </ListItemIcon>
                                                                            </Tooltip>
                                                                        )}
                                                                        {!record.icon && (
                                                                            <Tooltip
                                                                                title={record.tooltip}
                                                                                key={record.outcomeId}
                                                                                placement="right"
                                                                            >
                                                                                <ListItemIcon>
                                                                                    <SaveTwoToneIcon
                                                                                        sx={{ opacity: 0 }}
                                                                                    />
                                                                                </ListItemIcon>
                                                                            </Tooltip>
                                                                        )}
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={12}
                                                                        md={10}
                                                                        justifyContent={'left'}
                                                                        alignItems="left"
                                                                    >
                                                                        <Tooltip
                                                                            title={record.tooltip}
                                                                            key={record.outcomeId}
                                                                            placement="right"
                                                                        >
                                                                            <Typography
                                                                                variant="inherit"
                                                                                noWrap
                                                                                sx={{ color: record.buttonColor }}
                                                                                align="left"
                                                                            >
                                                                                &nbsp; {record.name}
                                                                            </Typography>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                </Grid>
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                                {hasGroup && (
                                                    <Link
                                                        sx={{ fontStyle: 'italic' }}
                                                        underline="hover"
                                                        component="button"
                                                        variant="caption"
                                                        onClick={() => goBackToGroupFromOutcome()}
                                                    >
                                                        go back
                                                    </Link>
                                                )}

                                                {activityOutcomeError && (
                                                    <Typography
                                                        variant="caption"
                                                        noWrap
                                                        sx={{ color: 'red' }}
                                                        align="left"
                                                    >
                                                        Outcome is required!
                                                    </Typography>
                                                )}
                                            </Grid>
                                        )}
                                        {showSubOutcomes && (
                                            <Grid
                                                item
                                                xs={12}
                                                md={12}
                                                spacing={2}
                                                alignContent="center"
                                                justifyContent={'center'}
                                                sx={{
                                                    pt: 4,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <InputLabel id="demo-simple-select-autowidth-labe2">
                                                    Select Outcome
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-autowidth-labe2"
                                                    id="selectedSubId"
                                                    size="small"
                                                    value={outcomeSubId}
                                                    autoWidth
                                                    displayEmpty
                                                    onChange={handleSubChange}
                                                    error={activityOutcomeError}
                                                >
                                                    {outcomesRecord.activitySubOutcomes
                                                        .filter((record) => record.activityOutcomeId == outcomeId)
                                                        .map((record) => (
                                                            <MenuItem key={record.id} value={record.id}>
                                                                <Grid container spacing={2} justifyContent={'center'}>
                                                                    <Grid item xs={12} md={2}>
                                                                        {record.icon && (
                                                                            <Tooltip
                                                                                title={record.tooltip}
                                                                                key={record.id}
                                                                                placement="right"
                                                                            >
                                                                                <ListItemIcon>
                                                                                    <Icon
                                                                                        icon={record.icon}
                                                                                        sx={{
                                                                                            color: record.buttonColor,
                                                                                        }}
                                                                                    ></Icon>
                                                                                </ListItemIcon>
                                                                            </Tooltip>
                                                                        )}
                                                                        {!record.icon && (
                                                                            <Tooltip
                                                                                title={record.tooltip}
                                                                                key={record.id}
                                                                                placement="right"
                                                                            >
                                                                                <ListItemIcon>
                                                                                    <SaveTwoToneIcon
                                                                                        sx={{ opacity: 0 }}
                                                                                    />
                                                                                </ListItemIcon>
                                                                            </Tooltip>
                                                                        )}
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={12}
                                                                        md={10}
                                                                        justifyContent={'left'}
                                                                        alignItems="left"
                                                                    >
                                                                        <Tooltip
                                                                            title={record.tooltip}
                                                                            key={record.id}
                                                                            placement="right"
                                                                        >
                                                                            <Typography
                                                                                variant="inherit"
                                                                                noWrap
                                                                                sx={{ color: record.buttonColor }}
                                                                                align="left"
                                                                            >
                                                                                &nbsp; {record.name}
                                                                            </Typography>
                                                                        </Tooltip>
                                                                    </Grid>
                                                                </Grid>
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                                <Link
                                                    sx={{ fontStyle: 'italic' }}
                                                    underline="hover"
                                                    component="button"
                                                    variant="caption"
                                                    onClick={() => goBackToOutcomeFromSub()}
                                                >
                                                    go back
                                                </Link>
                                                {activityOutcomeError && (
                                                    <Typography
                                                        variant="caption"
                                                        noWrap
                                                        sx={{ color: 'red' }}
                                                        align="left"
                                                    >
                                                        Outcome is required!
                                                    </Typography>
                                                )}
                                            </Grid>
                                        )}
                                        {showDCSchedule && (
                                            <Box width="100%">
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={12}
                                                    spacing={2}
                                                    alignContent="center"
                                                    justifyContent={'center'}
                                                    sx={{
                                                        pt: 4,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flexDirection: 'column',
                                                    }}
                                                >
                                                    <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
                                                        If you know the date for the discovery call enter it here, if
                                                        not the date will be assigned based on the cadence
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={12}
                                                    spacing={2}
                                                    alignContent="center"
                                                    justifyContent={'center'}
                                                    sx={{
                                                        pt: 4,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flexDirection: 'column',
                                                    }}
                                                >
                                                    <CustomDatePickerNoError
                                                        label="Discovery Call Date"
                                                        value={outcomesRecord.discoveryCallDate}
                                                        onChange={(value) =>
                                                            LeadActivityOutcomeStore.update((s) => {
                                                                s.record.discoveryCallDate = value;
                                                            })
                                                        }
                                                    />
                                                </Grid>
                                            </Box>
                                        )}
                                        {showNextActivity && (
                                            <Box width="100%">
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={12}
                                                    spacing={2}
                                                    alignContent="center"
                                                    justifyContent={'center'}
                                                    sx={{
                                                        pt: 4,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flexDirection: 'column',
                                                    }}
                                                >
                                                    <FormControl>
                                                        <InputLabel id="demo-simple-select-labelz">
                                                            Select New Activity
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-labelz"
                                                            id="demo-simple-select"
                                                            value={selectedActivity}
                                                            label="Select New Activity"
                                                            onChange={handlenewActivityChange}
                                                            size="small"
                                                            sx={{ width: 400 }}
                                                        >
                                                            {activities.map((option) => (
                                                                <MenuItem key={option.value} value={option.value}>
                                                                    {option.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={12}
                                                    spacing={2}
                                                    alignContent="center"
                                                    justifyContent={'center'}
                                                    sx={{
                                                        pt: 4,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flexDirection: 'column',
                                                    }}
                                                >
                                                    <CustomDatePickerNoError
                                                        label="New Activity Date"
                                                        value={outcomesRecord.nextActivityDate}
                                                        onChange={(value) =>
                                                            LeadActivityOutcomeStore.update((s) => {
                                                                s.record.nextActivityDate = value;
                                                            })
                                                        }
                                                    />
                                                </Grid>
                                            </Box>
                                        )}
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            spacing={2}
                                            alignContent="center"
                                            justifyContent={'center'}
                                            sx={{
                                                pt: 4,
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Tooltip title="Save">
                                                <LoadingButton
                                                    size="small"
                                                    onClick={onSubmit}
                                                    endIcon={<SaveTwoToneIcon />}
                                                    loading={submitting}
                                                    loadingPosition="end"
                                                    variant="contained"
                                                    disabled={outcomesRecord.saveDisabled}
                                                >
                                                    <span>Save & Close</span>
                                                </LoadingButton>
                                                {/*<Button variant="contained" disabled={outcomesRecord.saveDisabled} color="info" onClick={onSubmit} startIcon={<SaveTwoToneIcon />} sx={{ mr: 3 }} >*/}
                                                {/*    Save & Close*/}
                                                {/*</Button>*/}
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    } else {
        return (
            <Box>
                There is a configuration issue with outcomes. Error: There are no outcomes configured for the current
                stage, please contact your administrator for help
            </Box>
        );
    }
};

export { DoActivityOutcomes };

export default DoActivityOutcomes;
